class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.results = this.querySelector('[data-predictive-search]');
    this.timer = null;
    this.controller = null;
    this.searchTerm = '';

    if (!this.input || !this.results) return;

    this.input.addEventListener('input', () => {
      clearTimeout(this.timer);
      const term = this.input.value.trim();
      this.searchTerm = term;

      if (!term) {
        this.close();
        return;
      }

      this.timer = setTimeout(() => this.getSearchResults(term), 220);
    });

    this.input.addEventListener('focus', () => {
      if (this.searchTerm && this.results.innerHTML.trim()) this.open();
    });

    document.addEventListener('click', (event) => {
      if (!this.contains(event.target)) this.close();
    });
  }

  getSearchResults(searchTerm) {
    if (this.controller) this.controller.abort();
    this.controller = new AbortController();

    const root = window.Shopify?.routes?.root || '/';
    const url =
      root +
      'search/suggest?q=' +
      encodeURIComponent(searchTerm) +
      '&resources[type]=product,query,collection&page=1&section_id=predictive-search';

    fetch(url, { signal: this.controller.signal })
      .then((response) => {
        if (!response.ok) throw new Error('Predictive search failed');
        return response.text();
      })
      .then((html) => {
        if (searchTerm !== this.searchTerm) return;

        const doc = new DOMParser().parseFromString(html, 'text/html');
        const section = doc.querySelector('#shopify-section-predictive-search');

        if (!section) {
          this.close();
          return;
        }

        this.results.innerHTML = section.innerHTML;
        this.open();
      })
      .catch((error) => {
        if (error.name !== 'AbortError') this.close();
      });
  }

  open() {
    this.setAttribute('open', '');
    this.input.setAttribute('aria-expanded', 'true');
    this.results.style.display = 'block';
  }

  close() {
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', 'false');
    this.results.style.display = 'none';
  }
}

if (!customElements.get('predictive-search')) {
  customElements.define('predictive-search', PredictiveSearch);
}
